import React from 'react';
import "react-datepicker/dist/react-datepicker.css";
import ReportsDateSelect from '../../commons/ReportsDateSelect/ReportsDateSelect';
import { AllGroupStockListType } from '../../../redux/clientSettings/clientSettingTypes';
import { DropDown } from '../../commons';
import  { OptionProps, components } from "react-select";


type DropDownItemType = {
  value: number | undefined|string;
  label: string | undefined;
};

type AppProps = {
  startDate?: any;
  endDate?: any;
  handleStartDateChange: (date: any) => void;
  handleEndDateChange: (date: any) => void;
  handleSubmitData?: () => void;
  toggle: boolean;
  setToggle: (data: boolean) => void;
  groupStockList: [] | AllGroupStockListType[];
  stockGroupName: DropDownItemType;
  setStockGroupName:React.Dispatch<React.SetStateAction<DropDownItemType>>;


};

const StockReportsSummaryHeader = ({
  toggle,
  setToggle,
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  handleSubmitData,
  groupStockList,
  stockGroupName,
  setStockGroupName
}: AppProps) => {

let finalOptions: any = groupStockList?.map((e: any) => {
    return {
      value: e.stock_group_id,
      label: e.stock_group_name,
      count: e.count,
    };
  });

  const handleGroupNameData = (mode: any) => {
    setStockGroupName({
      value: mode?.value,
      label: mode?.label,
    });
  };

  const Option = (props: OptionProps<any, false>) => {
      return (
        <components.Option {...props}>
          <ul className={`ledger-list`}>
            <li
              style={{
                paddingLeft: `${
                  props?.data?.count !== undefined ? props?.data?.count * 10 : "0"
                }px`,
              }}
            >
              <span
                className={
                  props?.data?.count === undefined
                    ? ""
                    : "stock-nested-list no-show"
                }
              >
                {props?.children}
              </span>
            </li>
          </ul>
        </components.Option>
      );
    };

  return (
    <div className='d-flex justify-content-start align-items-center'>
      <div className='form-group'>
        <label>Date</label>
        <div>
          <ReportsDateSelect
            setToggle={setToggle}
            toggle={toggle}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
          />
        </div>
      </div>

      <div className="col-md-3 form-group">
        <label>Stock Group </label>
        <div>
          <DropDown
            options={
              finalOptions
                ? [{ value: "", label: "Select Stock Group..." }, ...finalOptions]
                : [{ value: "", label: "Select Stock Group..." }]
            }
            value={stockGroupName}
            handleChange={handleGroupNameData}
            components={{ Option }}

          />
        </div>
      </div>
      <div className="col-md-3 mt-2">
        <button
          className="btn btn-primary"
          onClick={handleSubmitData}
          disabled={!startDate?.length || !endDate?.length}
        >
          Get Stock Summary
        </button>
      </div>
    </div>
  )
};

export default StockReportsSummaryHeader;